// extracted by mini-css-extract-plugin
export default {"box":"formSelect_box__MRJTO","box__select":"formSelect_box__select__Tnwcr","box__option":"formSelect_box__option__AvT3p"};